import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import { toastr } from "react-redux-toastr";
import ErrorMessage from "../../../../components/text/ErrorMessage";

import { useDataLoader } from "react-remote-data-hooks";
import {
  Company,
  UpdateCompanyData,
} from "../../../../core/api/models/company";
import api from "../../../../api";

interface FormProps {
  name?: string;
}

const EditCompany: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateCompany: (details: Company) => void;
  details?: Company;
  property: string;
  value?: string;
  title: string;
  loadData?: () => Promise<any[]>;
  options?: any[];
  type?: string;
}> = (props) => {
  const { loadData } = props;
  const { data } = useDataLoader<any[]>(() => {
    if (loadData) {
      return loadData();
    }
  });

  const { control, handleSubmit, errors, watch } = useForm<FormProps>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const onSubmit = (updateData?: any) => {
    onUpdate(updateData.name);
  };

  const onUpdate = async (value: string) => {
    const updateData: UpdateCompanyData = {
      name: props.details?.name,
      cinNumber: props.details?.cinNumber,
      fan: props.details?.fan,
      sector: props.details?.sector?._id,
      industry: props.details?.industry?._id,
      companySegment: props.details?.companySegment?._id,
      // salesType: props.details?.salesType?._id,
      addresses: props.details?.addresses,
      [props.property]: value,
    };

    try {
      const response = await api.company.updateCompnay(
        updateData,
        props.details?._id
      );

      props.updateCompany(response);
      props.onClose();
      toastr.success("Success", `${props.title} updated successfully`);
    } catch (error) {
      if (error?.response?.data?.message) {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
  };

  const onFieldUpdate = (e: { key: string }) => {
    if (e.key === "Enter") {
      onUpdate(watch("name") || "");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mt-2 d-flex flex-wrap px-4 py-2 border-top border-bottom contact-form-row active align-items-center">
        <div className="col px-2 contact-label font-xs text-gray-500">
          {props.title}
        </div>
        <div className="col px-2 contact-content d-flex align-items-center">
          {props.type === "select" ? (
            <Controller
              control={control}
              rules={{
                required: true,
                validate: (value) => {
                  return !!value.trim();
                },
              }}
              name={"name"}
              defaultValue={props.value}
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={data || props.options}
                  textField={"name"}
                  valueField={"_id"}
                  placeholder={props.title}
                  onChange={(val) => {
                    onChange(val._id);
                  }}
                />
              )}
            />
          ) : props.title !== "FAN" ? (
            <Controller
              control={control}
              rules={{
                required: true,
                validate: (value) => {
                  return !!value.trim();
                },
              }}
              name={"name"}
              defaultValue={props.value}
              render={({ onChange, value, name }) => (
                <input
                  type="text"
                  className="font-sm font-weight-semibold form-control form-control-sm"
                  placeholder={props.title}
                  name={name}
                  value={value}
                  onChange={onChange}
                  onKeyDown={onFieldUpdate}
                  id={props.property}
                />
              )}
            />
          ) : (
            <Controller
              control={control}
              // rules={{
              //   required: true,
              //   validate: (value) => {
              //     return !!value.trim();
              //   },
              // }}
              name={"name"}
              defaultValue={props.value}
              render={({ onChange, value, name }) => (
                <input
                  type="text"
                  className="font-sm font-weight-semibold form-control form-control-sm"
                  placeholder={props.title}
                  name={name}
                  value={value}
                  onChange={onChange}
                  onKeyDown={onFieldUpdate}
                  id={props.property}
                />
              )}
            />
          )}
          {errors.name && (
            <ErrorMessage>{props.title} is required</ErrorMessage>
          )}
        </div>

        <div className="col-12 px-2 mt-1 text-right">
          <button
            type="submit"
            className="btn btn-sm btn-outline-dark mr-2 font-normal"
            onClick={props.onClose}
          >
            Cancel
          </button>
          <button className="btn btn-sm btn-primary font-normal">Save</button>
        </div>
      </div>
    </form>
  );
};

export default EditCompany;
